import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Box,
  Container,
  Typography,
  Button,
  useMediaQuery,
} from "@mui/material";
import { Person, DialpadSharp, Lock } from "@mui/icons-material";
import { useLoader } from "../context/LoaderContext";
import axios from "axios";
import { host } from "../constant/backendpath";
import AuthInput from "./AuthInput";
import logo from "../assets/img/logo2.svg";
import Alert from "../widgets/AlertModal";

const Forgetpassword = ({ setCurrent }) => {
  const [isVerify, setIsVerify] = useState(true);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [passwordVisibility2, setPasswordVisibility2] = useState(false);
  const isMobile = useMediaQuery("(max-width:733px)");
  // const navigate = useNavigate();
  const { setLoading } = useLoader();
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [open, setOpen] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [sent, setSent] = useState(false);
  const [otpSecondsLeft, setOtpSecondsLeft] = useState(0);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{6,}$/;
  const otpRegex = /^\d{6}$/;
  // console.log(isVerify)
  const validateOPTVerify = () => {
    const newErrors = {};
    if (!emailRegex.test(email)) newErrors.email = true;
    if (!otpRegex.test(otp)) newErrors.otp = true;
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    setIsVerify(true);
  }, []);

  const togglePasswordVisibility = () => setPasswordVisibility((prev) => !prev);
  const togglePasswordVisibility2 = () =>
    setPasswordVisibility2((prev) => !prev);

  useEffect(() => {
    if (!otpSecondsLeft) return;
    const timer = setTimeout(() => {
      setOtpSecondsLeft((prev) => prev - 1);
    }, 1000);
    return () => clearTimeout(timer);
  }, [otpSecondsLeft]);

  useEffect(() => {
    if (otpSecondsLeft === 0) {
      setSent(false);
    }
  }, [otpSecondsLeft]);

  const vsendotp = async () => {
    if (!emailRegex.test(email)) {
      setErrors({ email: true });

      setAlertMessage("Enter a valid email");
      setAlertType("error");
      setOpen(true);
      return;
    }
    try {
      setSent(true);
      const res = await axios.post(`${host}forgetpass/otpSend`, {
        toemail: email,
        type: "forget",
      });
      if (res.status === 200) {
        setOtpSent(true);
        setOtpSecondsLeft(120);
        setAlertMessage("OTP Sent Successfully");
        setAlertType("info");
        setOpen(true);
      }
    } catch (error) {
      setAlertMessage(error.response?.data?.msg || "Failed to send OTP");
      setAlertType("error");
      setOpen(true);
      setSent(false);
      setOtpSecondsLeft(0);
    }
  };

  const emailOtpFields = [
    {
      label: "Enter your Mail ID",
      name: "email",
      value: email,
      onChange: (e) => setEmail(e.target.value),
      icon: Person,
      isError: errors.email,
      isValid: emailRegex.test(email),
      sendotp: vsendotp,
      sent: sent,
      otpSecondsLeft: otpSecondsLeft,
    },
    {
      label: "Enter OTP",
      name: "otp",
      value: otp,
      onChange: (e) => setOtp(e.target.value),
      icon: DialpadSharp,
      isValid: otpRegex.test(otp),
      isError: errors.otp,
      disabled: !otpSent,
      sent: sent,
    },
  ];

  const passwordFields = [
    {
      label: "New Password",
      name: "newPassword",
      value: newPassword,
      onChange: (e) => setNewPassword(e.target.value),
      icon: Lock,
      isPassword: true,
      showPassword: passwordVisibility,
      isValid: passwordRegex.test(newPassword),
      togglePassword: togglePasswordVisibility,
    },
    {
      label: "Confirm Password",
      name: "confirmPassword",
      value: confirmPassword,
      onChange: (e) => setConfirmPassword(e.target.value),
      icon: Lock,
      isPassword: true,
      showPassword: passwordVisibility2,
      togglePassword: togglePasswordVisibility2,
    },
  ];

  const renderFields = (fields) =>
    fields.map((field) => <AuthInput key={field.name} {...field} />);

  const handleVerify = async () => {
    if (!validateOPTVerify()) return;
    setLoading(true);
    try {
      const res = await axios.post(
        `${host}verifyOtp`,
        { email, otp },
        { withCredentials: true },
      );
      if (res.status === 200) {
        setIsVerify(false);
      }
    } catch (error) {
      console.error(error);
      setAlertMessage("OTP verification failed");
      setAlertType("error");
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        minHeight: "100vh",
        width: "100%",
        py: { xs: 3, sm: 5, md: 6 },
        px: { xs: 1.5, sm: 2, md: 3 },
        background:
          "linear-gradient(180deg, #f5f8ff 0%, #eaf4ff 55%, #ffffff 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          pb: 0,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          marginBottom: 2,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Thiran Logo"
          sx={{ width: { xs: 56, sm: 72 }, height: { xs: 56, sm: 72 } }}
        />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            letterSpacing: "0.12em",
            color: "#0f4e99",
            fontSize: { xs: "1.3rem", sm: "1.5rem" },
          }}
        >
          THIRAN
        </Typography>
      </Box>
      <Box
        sx={{
          width: { xs: "100%", sm: "100%", md: "90%", lg: "540px" },
          maxWidth: 540,
          borderRadius: { xs: "24px", sm: "32px" },
          backgroundColor: "rgba(255,255,255,0.98)",
          boxShadow: "0 32px 80px rgba(37, 64, 97, 0.12)",
          border: "1px solid rgba(7, 151, 243, 0.14)",
          overflow: "hidden",
          position: "relative",
          paddingTop: { xs: 3, sm: 5 },
        }}
      >
        <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, pb: { xs: 3, sm: 4 } }}>
          <Box
            sx={{
              width: "100%",
              minHeight: isMobile ? "auto" : 260,
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  mb: 2,
                  color: "#0f4e99",
                  textAlign: "center",
                }}
              >
                {isVerify ? "OTP Verification" : "Change Password"}
              </Typography>
              <Box sx={{ marginLeft: { xs: 0, sm: 2, md: 5 } }}>
                {isVerify
                  ? renderFields(emailOtpFields)
                  : renderFields(passwordFields)}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  gap: 2,
                  justifyContent: "space-between",
                  alignItems: isMobile ? "stretch" : "center",
                  mt: 3,
                  width: "100%",
                }}
              >
                {isVerify && (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#4c5f7f",
                      textAlign: isMobile ? "center" : "left",
                    }}
                  >
                    Didn't receive OTP?{" "}
                    <Button
                      color="primary"
                      sx={{ textTransform: "none", p: 0, minWidth: 0 }}
                      onClick={vsendotp}
                      disabled={!emailRegex.test(email) || otpSecondsLeft > 0}
                    >
                      {otpSecondsLeft > 0
                        ? `Resend in ${otpSecondsLeft}s`
                        : "Resend"}
                    </Button>
                  </Typography>
                )}
                <Button
                  onClick={
                    isVerify
                      ? handleVerify
                      : async () => {
                          if (!passwordRegex.test(newPassword)) {
                            setAlertMessage(
                              `Use a strong password: \n
                              at least 6 characters with uppercase, lowercase, and a special symbol.`
                            );
                            setAlertType("warning");
                            setOpen(true);
                            return;
                          }
                          if (newPassword !== confirmPassword) {
                            setAlertMessage("Passwords do not match");
                            setAlertType("error");
                            setOpen(true);
                            return;
                          }
                          setLoading(true);
                          try {
                            const res = await axios.post(
                              `${host}changePassword`,
                              { email, newPassword },
                              { withCredentials: true },
                            );
                            if (res.status === 200) {
                              setAlertMessage("Password changed successfully");
                              setAlertType("info");
                              setOpen(true);
                              setCurrent(4);
                            }
                          } catch (error) {
                            console.error(error);
                            setAlertMessage("Failed to change password");
                            setAlertType("error");
                            setOpen(true);
                          } finally {
                            setLoading(false);
                          }
                        }
                  }
                  variant="contained"
                  size="small"
                  disabled={
                    isVerify
                      ? !emailRegex.test(email) || !otpRegex.test(otp)
                      : confirmPassword.length === 0
                  }
                >
                  {isVerify ? "Verify" : "Change Password"}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Alert
        open={open}
        setOpen={setOpen}
        message={alertMessage}
        type={alertType}
      />
    </Container>
  );
};

export default Forgetpassword;
